import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ProductCatalog} from '../../../models/product-catalog.model';
import {Order} from '../../../models/order.model';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';
import {Product} from '../../../models/product.model';

export const PROGRAMS_ITEMS  = 4;
export const PRODUCTS_ITEMS = 5;

const PROGRAMS_BREAKPOINTS =  [
  {
    breakpoint: '1290px',
    numVisible: 3,
    numScroll: 3
  },
  {
    breakpoint: '998px',
    numVisible: 2,
    numScroll: 2
  },
  {
    breakpoint: '675px',
    numVisible: 1,
    numScroll: 1
  }];

const PRODUCTS_BREAKPOINTS =  [
  {
    breakpoint: '1110px',
    numVisible: 4,
    numScroll: 4
  }, {
    breakpoint: '890px',
    numVisible: 3,
    numScroll: 3
  }, {
    breakpoint: '528px',
    numVisible: 2,
    numScroll: 2
  }];


@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CarouselComponent implements OnInit {

  @Input() items:  Product[] | ProductCatalog[];
  @Input() order: Order;

  constructor(private mobileService: MobileCheckServiceService) { }

  ngOnInit(): void {
  }


  get itemsCount(): number {
    return this.items?.length || 0;
  }

  get visibleItems(): number {
    const count = this.isProgramType ? PROGRAMS_ITEMS : PRODUCTS_ITEMS;
    return Math.min(this.itemsCount, count);
  }

  get isMobile(): boolean {
    return this.mobileService.mobileDevice;
  }

  get isTable(): boolean {
    return this.mobileService.tabletDevice;
  }

  get showNavigation(): boolean {
    return this.itemsCount > this.visibleItems;
  }


  get isProgramType(): boolean {
    if (!this.itemsCount) {
      return false;
    }
    return this.items[0] instanceof ProductCatalog;
  }


  get responsiveOptions() {
    if (this.isProgramType) {
      return PROGRAMS_BREAKPOINTS;
    }
    return PRODUCTS_BREAKPOINTS;
  }

}
